(function () {
  'use strict';

  angular.module('wsLrs.controllers').config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/settings', {
      controller: 'SettingsRedirectCtrl',
      template: '<div></div>'
    });
  }]).controller('SettingsRedirectCtrl', ['$location', 'SettingsDropdownLinks', function ($location, SettingsLinks) {
    $location.replace();
    var path = "",
      firstEnabledLink = _.find(SettingsLinks.get('settings'), function (link) {
        return link.condition === true;
      });
    if (firstEnabledLink) {
      var linkHref = firstEnabledLink.href;
      path = linkHref.charAt(0) === '#' ? linkHref.slice(1) : linkHref;
    }
    $location.path(path);
  }]).controller('SettingsNavCtrl', ['$scope', 'User', 'SettingsDropdownLinks', 'Analytics', function ($scope, User, SettingsLinks, Analytics) {
    var user = User.get();
    $scope.organizationName = user.organization.name;
    Analytics.settingsViewed();
    $scope.settingsLinks = SettingsLinks.get('settings');
  }]);
})();
